export default __webpack_public_path__ + "static/media/Frame 187.f2101daf.svg";